
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopuneonlinecab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Online Cab',
        heading: 'Skyline Cabs: Mumbai to Pune Online Cab',
        headingDescription: 'Skyline Cabs offers convenient and reliable Mumbai to Pune Online Cab booking services for a smooth and comfortable travel experience. Whether you are traveling for work, leisure, or airport transfers, booking your cab online with us is quick and hassle-free. Our well-maintained vehicles, experienced drivers, and 24/7 customer support ensure a safe and timely journey from Mumbai to Pune. With transparent pricing and flexible scheduling, Skyline Cabs is your perfect choice for intercity travel. Book your Mumbai to Pune online cab today and travel with ease!',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Online Cab",
      "description": "Book your Mumbai to Pune cab online 24x7 with Skyline Cabs. Our easy-to-use booking platform offers instant confirmations, transparent pricing, and multiple vehicle choices including sedans, Ertigas, and Innova Crystas. Perfect for business trips, family travel, or airport transfers."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Online Booking",
      "description": "Skyline Cabs offers seamless online taxi booking from Mumbai Airport to Pune. Whether you're arriving late night or early morning, enjoy instant confirmations, fixed fares, and trained chauffeurs for a reliable airport transfer experience."
    },
    {
      "name": "Mumbai to Pune Online Innova Taxi",
      "description": "Looking for a premium travel option? Book an Innova Crysta online for your Mumbai to Pune trip with Skyline Cabs. Enjoy spacious seating, air conditioning, and smooth highway rides, perfect for family or group travel."
    },
    {
      "name": "Mumbai to Pune Online Ertiga Taxi",
      "description": "Skyline Cabs provides affordable online booking for Ertiga taxis from Mumbai to Pune. A perfect blend of comfort and cost-efficiency, Ertiga is ideal for group travel, corporate rides, or long-distance family trips."
    },
    {
      "name": "Mumbai to Pune Online Round Trip Taxi",
      "description": "Planning a return trip? Book a round trip taxi online from Mumbai to Pune and back with Skyline Cabs. Get special fares, reliable service, and the flexibility to plan your schedule as you like."
    },
    {
      "name": "Online Cab Booking Mumbai to Pune",
      "description": "Experience hassle-free online cab booking from Mumbai to Pune with Skyline Cabs. Choose your preferred vehicle, schedule your ride, and travel stress-free with our professional and punctual drivers."
    },
    {
      "name": "Mumbai to Pune 24x7 Cab Booking",
      "description": "Skyline Cabs offers round-the-clock online booking for Mumbai to Pune cab services. Whether it’s an early flight or a late meeting, we’re available 24/7 with quick confirmations and comfortable rides."
    },
    {
      "name": "Online Cab Booking Pune to Mumbai",
      "description": "Traveling back to Mumbai? Skyline Cabs lets you book your Pune to Mumbai cab online within minutes. Enjoy reliable intercity travel with fixed fares, clean vehicles, and courteous chauffeurs."
    },
    {
      "name": "Mumbai Online Cab Booking",
      "description": "Skyline Cabs provides comprehensive online cab booking services within Mumbai. Whether for local, airport, or outstation travel, book instantly online and choose from a range of vehicles suited to your needs."
    },
    {
      "name": "Online Taxi Booking from Mumbai Airport",
      "description": "Book a taxi online from Mumbai Airport with Skyline Cabs. We offer door-to-door service to Pune and other destinations, with real-time tracking, multiple payment options, and 24/7 customer support."
    },
    {
      "name": "Online Cab Service in Mumbai",
      "description": "Skyline Cabs offers a full-fledged online cab service in Mumbai. From quick city rides to long outstation journeys, book online and travel safely with our fleet of well-maintained vehicles."
    },
    {
      "name": "Outstation Taxi Service in Mumbai",
      "description": "Skyline Cabs is your go-to solution for online outstation taxi bookings from Mumbai. Get instant quotes, real-time availability, and experienced drivers for a stress-free intercity ride to Pune or any nearby city."
    },
    {
      "name": "Mumbai Airport to Pune Station Cab Service Rates",
      "description": "Skyline Cabs offers fixed, transparent cab fare from Mumbai Airport to Pune Railway Station. Whether it’s a sedan, Ertiga, or Innova Crysta, our rates include tolls, driver charges, and fuel costs with no hidden fees."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Online Cab", "Mumbai Airport to Pune Taxi Online Booking"],
    ["Mumbai to Pune Online Innova Taxi", "Mumbai to Pune Online Ertiga Taxi"],
    ["Mumbai to Pune Online Round Trip Taxi", "Online Cab Booking Mumbai to Pune"],
    ["Mumbai to Pune 24x7 Cab Booking", "Online Cab Booking Pune to Mumbai"],
    ["Mumbai Online Cab Booking", "Online Taxi Booking from Mumbai Airport"],
    ["Online Cab Service in Mumbai", "Outstation Taxi Service in Mumbai"],
    ["Mumbai Airport to Pune Station Cab Service Rates", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Easy Online Booking for Mumbai to Pune Cabs",
        "WhyChoosedescription": "Booking your Mumbai to Pune cab has never been easier with Skyline Cabs. Our user-friendly website and mobile app allow you to book a cab anytime, anywhere, with instant confirmation and live tracking features for a seamless experience from start to finish."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained, air-conditioned vehicles ensures a comfortable ride for your journey from Mumbai to Pune. Whether you're traveling solo, with family, or in a group, we have sedans, SUVs, and luxury cars to cater to your preferences and comfort."
    },
    {
        "WhyChooseheading": "Professional Drivers for a Smooth Ride",
        "WhyChoosedescription": "Skyline Cabs drivers are highly skilled, background-checked, and well-versed in the Mumbai to Pune route. They prioritize your comfort and safety, ensuring you arrive at your destination on time, every time, with a smooth and stress-free ride."
    },
    {
        "WhyChooseheading": "Transparent Pricing and No Hidden Charges",
        "WhyChoosedescription": "With Skyline Cabs, you get upfront, transparent pricing. There are no hidden fees or surprises—just a clear, affordable fare for your Mumbai to Pune trip. Our pricing structure is competitive and designed to offer the best value for quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for On-Demand Travel",
        "WhyChoosedescription": "No matter when you need a ride, Skyline Cabs is available 24/7. Whether you're planning a last-minute trip, catching an early flight, or returning late at night, you can book your Mumbai to Pune cab anytime through our easy-to-use online platform."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "Choose the best vehicle for your journey, whether it's a compact sedan for a solo trip or a spacious SUV for a family or business group. Skyline Cabs offers a variety of well-maintained options, ensuring a comfortable, hassle-free ride from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Secure Online Payment and Booking",
        "WhyChoosedescription": "Booking your Mumbai to Pune cab online is secure and convenient. Our platform supports a variety of payment methods, including credit cards, debit cards, and online wallets, ensuring that your transaction is simple and safe."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Rides Every Time",
        "WhyChoosedescription": "Skyline Cabs prioritizes your safety. All our vehicles are sanitized after every ride, and our drivers follow strict safety protocols. Enjoy a safe, clean, and secure ride from Mumbai to Pune, whether you're traveling for business, leisure, or personal reasons."
    }
]
























    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a Mumbai to Pune cab online with Skyline Cabs?',
            answer:
                'Booking is easy! Just visit our website or use the Skyline mobile app, enter your pickup location in Mumbai and drop-off in Pune, choose your preferred car, and confirm your booking instantly.',
        },
        {
            id: 2,
            question: 'Can I schedule my online cab in advance?',
            answer:
                'Yes, you can pre-book your Mumbai to Pune cab online for any future date and time. We recommend booking in advance for better availability, especially during weekends or holidays.',
        },
        {
            id: 3,
            question: 'Is online payment available for booking?',
            answer:
                'Yes, we support secure online payment options including UPI, credit/debit cards, and net banking. You’ll receive an instant confirmation after successful payment.',
        },
        {
            id: 4,
            question: 'What kind of vehicles can I book online for this route?',
            answer:
                'You can book from a wide range of cars including Sedans, SUVs, Ertiga, Innova Crysta, and even luxury options — all available directly on our website or app.',
        },
        {
            id: 5,
            question: 'Can I track my cab after online booking?',
            answer:
                'Yes, once your booking is confirmed, you’ll receive real-time tracking updates along with driver and vehicle details — ensuring full transparency and security.',
        },
        {
            id: 6,
            question: 'Are there any cancellation charges for online bookings?',
            answer:
                'We offer flexible cancellation policies. If you cancel within the free window, there are no charges. Please refer to our cancellation policy during booking for exact details.',
        },
        {
            id: 7,
            question: 'Is the fare shown online final and inclusive of all charges?',
            answer:
                'Yes, the fare you see online includes tolls, taxes, and driver charges. There are no hidden fees — complete transparency guaranteed.',
        },
        {
            id: 8,
            question: 'Can I book a return trip online?',
            answer:
                'Definitely. While booking your Mumbai to Pune cab online, simply select the round-trip option and provide your return date/time.',
        },
        {
            id: 9,
            question: 'What if I need to make changes after booking online?',
            answer:
                'You can easily modify your ride details through our website or app. Our customer support is also available 24/7 for any assistance.',
        },
        {
            id: 10,
            question: 'Why book a Mumbai to Pune cab online with Skyline?',
            answer:
                'Skyline Cabs offers quick online booking, professional drivers, clean cars, transparent pricing, and 24x7 customer support — making your intercity travel effortless and dependable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sameer Kulkarni",
            rating: 5,
            review: "Booked a cab online from Mumbai to Pune through Skyline’s website. The whole process took less than 2 minutes and everything went smoothly. Super convenient and reliable!"
        },
        {
            name: "Miss. Sneha Pawar",
            rating: 4,
            review: "Loved how simple it was to book my ride online. The cab arrived on time, the driver was courteous, and the trip to Pune was really comfortable. Highly recommended!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Online Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pune-online-cab.jpg",
  "description": "Book Mumbai to Pune online cabs with Skyline Cabs for a quick, safe, and affordable journey. Enjoy 24/7 booking of AC sedans and SUVs with verified drivers—perfect for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8271"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pune-online-cabs"
  }
};


      
    
      


    return (
        <div>

<Helmet>
  <title>Mumbai to Pune Online Cabs | 24/7 AC Cab Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune online cabs with Skyline Cabs for a quick, safe, and affordable journey. Enjoy 24/7 booking of AC sedans and SUVs with verified drivers—perfect for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Online Cabs, Online Cab Booking Mumbai to Pune, One-Way Online Taxi Mumbai Pune, AC Cabs Mumbai to Pune, SUV Online Cabs Mumbai Pune, Skyline Cabs Online Booking, 24/7 Taxi Mumbai to Pune, Affordable Online Cab Mumbai to Pune, Mumbai Pune Sedan Cab, Book Cab Online Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/41.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneonlinecab;